import * as React from "react";
import { ViewModal } from "../../../components/modals/viewModal";

import { store } from "../../../store";
import { formSet, useCpFormAnyValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props {
  title: string;
  kind: string;
  namePath: string;
  inputToItemFn: any;
}
export const CpDebugModal: React.FC<Props> = ({ title, kind, namePath, inputToItemFn }) => {
  const { id } = useCpFormContext();
  const isDebugging = useCpFormAnyValue(`meta.debugging`);
  const name = useCpFormValue(namePath);

  if (!isDebugging) {
    return null;
  }

  return (
    <ViewModal
      kind={"kind"}
      onClose={() => formSet(id, `meta.debugging`, false)}
      title={title}
      object={() => {
        const form = store.getState().form.instances[id];
        const fieldStates = form.fieldStates;
        const errors = form.errors;
        const warnings = form.warnings;
        const values = form.values;
        const dirty = form.dirty;
        try {
          return {
            fieldStates: fieldStates,
            errors: errors,
            warnings: warnings,
            dirty: dirty,
            values: values,
            item: inputToItemFn(values),
          };
        } catch (e) {
          return {
            fieldStates: fieldStates,
            errors: errors,
            warnings: warnings,
            dirty: dirty,
            values: values,
            item: { error: e.message },
          };
        }
      }}
      visible={isDebugging}
      filename={`${kind}-${name}`}
    />
  );
};
